import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { bemJoin } from 'bem-join'

import { IntlMessageKeys, useIntl } from '@app/intl/Intl'
import { InfoTooltip } from '@app/lib/display/InfoTooltip/InfoTooltip'
import { TooltipMessage } from '@app/lib/display/TooltipMessage/TooltipMessage'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { TextInput } from '@app/lib/inputs/TextInput/TextInput'

export const FeeFactorInputField = ({ fieldName }: { fieldName: string }) => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()
  const { watch, setValue } = useFormContext()

  const courtCaseFee = watch('CourtCaseFee', 0)
  const fee = watch(fieldName, 0)
  const feeFactor = watch(`${fieldName}Factor`, 0)

  useEffect(() => {
    if (courtCaseFee && feeFactor) {
      setValue(fieldName, Math.round(courtCaseFee * feeFactor * 100) / 100)
    }
  }, [courtCaseFee, feeFactor, setValue])

  return (
    <InputField
      name={`${fieldName}Factor`}
      label={
        <InfoTooltip
          message={
            <TooltipMessage
              heading={formatMessage({
                id: `CourtCases.Invoicing.Field.${fieldName}` as IntlMessageKeys
              })}
              text={formatMessage({
                id: `CourtCases.Invoicing.Field.${fieldName}.Tooltip.Text` as IntlMessageKeys
              })}
            />
          }
        >
          {formatMessage({ id: `CourtCases.Invoicing.Field.${fieldName}` as IntlMessageKeys })}
        </InfoTooltip>
      }
      rules={{
        pattern: {
          value: /^[0-9]+(\.[0-9])?$/,
          message: formatMessage({ id: 'CourtCases.Invoicing.Field.Error.ValidValue' })
        }
      }}
      render={({ inputProps }) => {
        return (
          <div className={b('fee-field')} data-testid={`${fieldName}-factor`}>
            <TextInput
              {...inputProps}
              type={'number'}
              step={0.1}
              className={b('field', { sm: true })}
            />
            {`${fee.toFixed(2)}\u00A0€`}
          </div>
        )
      }}
    />
  )
}
